import { render, staticRenderFns } from "./AppActivityFilter.vue?vue&type=template&id=70e821e4"
import script from "./AppActivityFilter.vue?vue&type=script&lang=js"
export * from "./AppActivityFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports